<p-table [value]="sstsDataProgrammerFinishedSsta" dataKey="id" [scrollable]="true"
scrollHeight="35vh" [rowHover]="true" [tableStyle]="{ 'min-width': '50rem' }"
styleClass="p-datatable p-datatable-striped ">
<ng-template pTemplate="header">
    <tr>
        <th>Usuario</th>
        <th>Tiempo</th>
    </tr>
</ng-template>
<ng-template pTemplate="body" let-usuario>
    <tr>
        <td class="">{{usuario.user.username}}
        </td>
        <td>{{usuario.report}}</td>
    </tr>
</ng-template>
<ng-template pTemplate="emptymessage" class="w-100">
    <tr>
        <td colspan="12">
            <p-messages class="w-100"
                [value]="[{ severity: 'info', detail: 'No se encontraron resultados' }]"
                [enableService]="false" [closable]="false">
            </p-messages>
        </td>
    </tr>
</ng-template>
<!-- <ng-template pTemplate="footer" let-usuario>
    <tr>
        <td>Total general:</td>
        <td>{{sstsDataProgrammer.asignadas}}</td>
        <td>{{sstsDataProgrammer.canceladas}}</td>
        <td>{{sstsDataProgrammer.eliminadas}}</td>
        <td>{{sstsDataProgrammer.guardadas}}</td>
        <td>{{sstsDataProgrammer.pendientes}}</td>
        <td>{{sstsDataProgrammer.rechazadas}}</td>
        <td>{{sstsDataProgrammer.totalGeneral}}</td>
    </tr>
</ng-template> -->
</p-table>